import React, { useState, useCallback } from 'react';
import { Button, ButtonType } from '../../../../components/button';
import './sharing-indicator.scss';

export const SharingIndicator = ({spanText, btnText, onStopClick}) => {

  return (
    <div className="sharing-indicator-wrapper">
      <div className="sharing-indicator">
        <i className="icon icon-desktop"></i>
        <span className="text">{spanText}</span>
        <Button type={ButtonType.PRIMARY} onClick={onStopClick} data-test-id="stop-sharing-btn">
          {btnText}
        </Button>
      </div>
    </div>
  );
};
